<template>
  <div class="container">
    <Card
      class="login-form"
      icon="md-log-in"
      title="欢迎登录"
      :bordered="false"
    >
      <Form :model="form" ref="form" class="form" :rules="rules">
        <FormItem prop="userName">
          <Input
            type="text"
            v-model="form.userName"
            placeholder="请填写账号"
            prefix="md-person"
          />
        </FormItem>
        <FormItem prop="password">
          <Input
            type="password"
            v-model="form.password"
            placeholder="请填写密码"
            prefix="md-lock"
          />
        </FormItem>
        <FormItem>
          <Button type="primary" long @click="handleSubmit">登 录</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>
<script>
import { login, getCurrentUser } from "@/api/index";

export default {
  name: "loginPage",
  data() {
    return {
      form: {
        userName: "admin",
        password: "123456",
      },
      rules: {
        userName: [
          { required: true, message: "账号不能为空", trigger: "blur" },
          { min: 2, max: 32, message: "账号长度为4~32个字符", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 2, max: 32, message: "密码长度为8~32个字符", trigger: "blur" },
        ],
      },
      manageType: {
        0: "super",
        1: "toB",
        2: "company",
      },
    };
  },
  methods: {
    // 提交登录
    handleSubmit() {
      let _this = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          login(this.form).then((res) => {
            if (res.code === 200) {
              _this.$Message.success("登录成功");
              _this.getLoginUser();
            } else {
              _this.$Message.error("登录失败：" + res.msg);
            }
          });
        }
      });
    },
    // 获取登录用户信息
    getLoginUser() {
      let _this = this;
      getCurrentUser().then((res) => {
        if (res.code === 200) {
          // 记录个人信息
          sessionStorage.setItem("userId", res.info.id);
          sessionStorage.setItem("userName", res.info.userName);
          sessionStorage.setItem("userInfo", JSON.stringify(res.info));
          sessionStorage.setItem(
            "userRole",
            _this.manageType[res.info.manageType]
          );
          // 跳转页面，要根据用户类型判断
          _this.$router.push({
            path: "/home",
          });
        } else {
          _this.$Message.error("读取登录用户失败：" + res.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
  background: url("@/assets/images/login-bg.jpg") no-repeat;
  background-size: 100% 100%;
}
.login-form {
  position: absolute;
  right: 160px;
  top: 50%;
  transform: translateY(-60%);
  width: 360px;
}
</style>
